var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowtharrowdownGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7678 45.7678C24.7915 46.7441 23.2085 46.7441 22.2322 45.7678L6.32233 29.8579C5.34602 28.8816 5.34602 27.2986 6.32233 26.3223C7.29864 25.346 8.88155 25.346 9.85787 26.3223L24 40.4645L38.1421 26.3223C39.1184 25.346 40.7014 25.346 41.6777 26.3223C42.654 27.2986 42.654 28.8816 41.6777 29.8579L25.7678 45.7678ZM26.5 5L26.5 44L21.5 44L21.5 5L26.5 5Z",
    fill: "#00A556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowtharrowdownGreen);
export default __webpack_public_path__ + "static/media/growth arrow down_green.42af721b68afad21a3a5e03e22c9ede6.svg";
export { ForwardRef as ReactComponent };